import { displayArchivoNombre } from "./archivoDisplayName";
import { getCourseFileObjectKey, getCourseFileViewUrl } from "./signedCourseFileUrl";

/**
 * @param {{ nombre?: string, storageKey?: string, url?: string } | null | undefined} archivo
 * @returns {string}
 */
export function getCourseMaterialDownloadFilename(archivo) {
  const name = displayArchivoNombre(archivo, "");
  return name || "documento";
}

/**
 * Downloads the same stored course file that the staff viewer opens.
 * Uses the authenticated file proxy and an octet-stream blob so the browser
 * saves the file instead of navigating away from course management.
 *
 * @param {{ nombre?: string, storageKey?: string, url?: string } | null | undefined} archivo
 * @returns {Promise<boolean>}
 */
export async function downloadCourseMaterial(archivo) {
  const objectKey = getCourseFileObjectKey(archivo);
  if (!objectKey) {
    return false;
  }

  let viewUrl = "";
  try {
    viewUrl = getCourseFileViewUrl(objectKey);
  } catch {
    return false;
  }

  const filename = getCourseMaterialDownloadFilename(archivo);
  try {
    const response = await fetch(viewUrl, { credentials: "include" });
    if (!response.ok) {
      return false;
    }
    const sourceBlob = await response.blob();
    const downloadBlob = new Blob([sourceBlob], { type: "application/octet-stream" });
    const downloadUrl = URL.createObjectURL(downloadBlob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    link.rel = "noopener noreferrer";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => {
      URL.revokeObjectURL(downloadUrl);
    }, 1500);
    return true;
  } catch {
    return false;
  }
}
